
export default class History {
  supportsHistory: boolean;

  constructor() {
    this.supportsHistory = !!(window.history && window.history.pushState);
  }

  pushState(data: any, title: string, url: string, referrer: string) {
    if (this.supportsHistory) {
      document.title = title;
      window.history.pushState(data, title, url);
  
      var getLastPathUrl = function (rawUrl: string) {
        var urlParts = rawUrl.split("/");
        var lastPart = urlParts[urlParts.length - 1].split("?")[0].split("#")[0];
        return lastPart;
      };
  
      // Trigger Analytics
      if (typeof analytics !== 'undefined' && getLastPathUrl(url) !== getLastPathUrl(referrer)) {
        analytics.page(title, {
          referrer: referrer
        });
      }
    }
  }

  pushStateNoTracking(data: any, title: string, url: string) {
    if (this.supportsHistory) {
      window.history.pushState(data, title, url);
    }
  }
}
